import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { inject } from '@angular/core';
import { GhostingService } from './ghosting.service';

export const ghostingInterceptorFn: HttpInterceptorFn = (req, next) => {
  const ghostingService = inject(GhostingService);
  const asUser = ghostingService.getAsUser();
  if (asUser && req.url.includes(environment.backendUri)) {
    return next(
      req.clone({
        headers: req.headers.set('X-As-User', asUser.id),
      }),
    );
  }
  return next(req);
};
